import { IBannerText } from '@/components/molecules/BannerText/BannerText';
import { IFilteredProjectsGallery } from '@/components/organisms/FilteredProjectsGallery/FilteredProjectsGallery.types';
import { TLangIso } from '@/types/global';
import { capitalizeFirstLetter } from '@/utils/generic';

export const generateWorkStructuredData = ({
  data,
  isWorkSpecificPage,
  subSlug,
  langIso,
}: {
  data: any;
  isWorkSpecificPage: boolean;
  subSlug: string;
  langIso: TLangIso;
}) => {
  let projectItems = [];
  const filteredProjectsGallery: IFilteredProjectsGallery =
    data?.components?.filter(
      (component: any) => component.type === 'FilteredProjectsGallery'
    )[0]?.props || [];

  projectItems = filteredProjectsGallery
    ? filteredProjectsGallery?.initialProjList[0]?.projects.map((project) => ({
        '@type': 'CreativeWork',
        name: project.title,
        url:
          langIso === 'en-US'
            ? `${process.env.NEXT_PUBLIC_SITE_URL}/${project.slug}`
            : `${process.env.NEXT_PUBLIC_SITE_URL}/es/${project.slug}`,
        image: project.image?.src,
        description:
          langIso === 'en-US'
            ? `Project in ${project.location}`
            : `Proyecto en ${project.location}`,
        author: {
          '@type': 'Organization',
          name: 'Berga&González',
        },
        ...(project.dateCreated && {
          datePublished: project.dateCreated.split('T')[0],
        }),
        ...(project.dateUpdated && {
          dateModified: project.dateUpdated.split('T')[0],
        }),
      }))
    : [];

  const bannerDescription: IBannerText =
    data?.components?.find(
      (component: any) => component.component === 'BannerText'
    )?.description || '';

  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: isWorkSpecificPage
      ? `${
          langIso === 'en-US'
            ? `${capitalizeFirstLetter(subSlug)} Projects`
            : `Proyectos de ${capitalizeFirstLetter(subSlug)}`
        }`
      : `${langIso === 'en-US' ? `Projects` : `Proyectos`}`,
    description: bannerDescription,
    url: `${process.env.NEXT_PUBLIC_SITE_URL}/${subSlug ? `/${subSlug}` : ''}`,
    itemListElement: projectItems,
  };
};
